import home from './home.js';


const api = {}
Object.assign(api, home)

console.log('api ==>', api)

export default api